import AddIcon from "@mui/icons-material/Add";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import { useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import { EDialogAction } from "../Components/Enum/DialogActionEnum";
import JobTitlesTable from "../Components/JobTitles/JobTitlesTable";
import JobTitlesDialogBox from "../Components/JobTitles/JobTitlesDialogBox";
import ProcessTable from "../Components/Process/ProcessTable";
import EventLogTable from "../Components/EventLog/EventLogTable";
import Scaffold from "../Components/Layout/Scaffold";

const EventLog = () => {
  let [filter, setfilter] = useState<any>({});

  return (
    <Scaffold
    title="Event Log"
    actions={[]}
    
    >

        <EventLogTable filter={filter} />

    </Scaffold>
  )

  return (
    <>
      <p className="text-2xl mb-3 ">Event Log</p>

      <div>
        <EventLogTable filter={filter} />
      </div>
    </>
  );
};

export default EventLog;
